import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';

import { createRoot } from 'react-dom/client';
import {MemberInfoCard} from '../../Components/Member';
import Swal from 'sweetalert2';
import API from '../../API';
import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/TALFC.css';

const PageMemberList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _MemberInfoCard = useRef();
    const [GroupList,setGroupList] = useState([]);

    useEffect(() => {
        (async () => {
            await _LoadGroupList();
        })();

        return ()=>{ }
    }, []);
    const _LoadGroupList = async()=>{
        API({method : "get",url:"/Member/Group/List"}).then(res=>{
            if (res.status !== 200) {
                return;
            }

            if (!res.data.Status) {
                return;
            }
            setGroupList(res.data.Data);
        }).catch(res => {
            return;
        });
    }
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Staff/Member/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.MemberGroupID = getValues('MemberGroup');
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _MemberInfoCard.current?.Show(d)}>Info</button>

        </div>
    )
    const _column = [
        { data: "MemberCode", name: "MemberCode", autoWidth: true },
        { data: "Name", name: "Name", autoWidth: true },
        { data: "MemberType", name: "MemberType", autoWidth: true,render(data){
            switch(data){
                case 1:return 'นักเรียน';
                case 2:return 'บุคลากร';
                case 3:return 'อื่นๆ';
                default : return 'ไม่ระบุ';
            }
        } },
        { data: "MemberGroupName", name: "MemberGroupName", autoWidth: true },
        { data: "Credit", name: "Credit", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        {data: "Updated", name: "Updated", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "MemberId", name: "MemberID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>จัดการข้อมูลสมาชิก</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                            <div className='row d-flex justify-content-end'>
                                <div className='col-13 col-lg-4 text-end'>
                                    <div className='input-group float-end'>
                                        <select className='form-control text-center' {...register("MemberGroup", { required: false })} defaultValue={0} onChange={(e)=>{setValue("MemberGroup",e.target.value);setTimeout(()=>{ref.current.load();},200)}} >
                                            <option value={null} selected>ทั้งหมด</option>
                                            {GroupList.map((v,i)=>{
                                                return <option key={i} value={v.MemberGroupId}>{v.MemberGroupName}</option>
                                            })}
                                        </select>
                                        <div className='btn btn-group'>
                                            <button type='button' className='btn btn-danger text-white' onClick={()=>{_MemberInfoCard.current?.Show(null);}}>เพิ่มสมาชิก</button>
                                            <button type='button' className='btn btn-warning text-white' onClick={()=>{}}>จัดการกลุ่ม</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="MemberTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                    <th className="text-center textcenter">รหัสเลขประจำตัว</th>
                                                    <th className="text-center textcenter">ชื่อ</th>
                                                    <th className="text-center textcenter">ประเภท</th>
                                                    <th className="text-center textcenter">กลุ่ม</th>
                                                    <th className="text-center textcenter">ยอดเงินคงเหลือ</th>
                                                    <th className="text-center textcenter">วันที่แก้ไข</th>
                                                    <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"MemberTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MemberInfoCard ref={_MemberInfoCard} update={()=>{ref.current?.load();}} />
        </React.Fragment>
        </>
    )
}

export default React.memo(PageMemberList)
